import Invoice from './invoice';

export default Invoice;
